/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { Form, Table } from 'react-bootstrap';
import '../Registrationsetup.scss';
import GetAdminConfiguration from '../../../api/GetAdminConfig';
import UserDefinedLabels from '../../../utils/UserDefinedLabels';

const AdditionalFields = (props) => {
  const iIndex = props.iIndex;
  const hasEditPermission = props.hasEditPermission;
  const personalIdentificationEditable = props.personalIdentificationEditable;
  const [state, setState] = React.useState({
    firstname:
      GetAdminConfiguration.FirstName[iIndex] === 'Visible' ? true : false,
    lastname:
      GetAdminConfiguration.LastName[iIndex] === 'Visible' ? true : false,
    email: GetAdminConfiguration.Email[iIndex] === 'Visible' ? true : false,
    dob: GetAdminConfiguration.DateOfBirth[iIndex] === 'Visible' ? true : false,
    addressline1:
      GetAdminConfiguration.AddressLine1[iIndex] === 'Visible' ? true : false,
    addressline2:
      GetAdminConfiguration.AddressLine2[iIndex] === 'Visible' ? true : false,
    city: GetAdminConfiguration.City[iIndex] === 'Visible' ? true : false,
    statename: GetAdminConfiguration.State[iIndex] === 'Visible' ? true : false,
    zipcode:
      GetAdminConfiguration.PostalCode[iIndex] === 'Visible' ? true : false,
    relationship:
      GetAdminConfiguration.Relationship[iIndex] === 'Visible' ? true : false,
    phonenumber:
      GetAdminConfiguration.PhoneNumber[iIndex] === 'Visible' ? true : false,
    clientid:
      GetAdminConfiguration.ClientID[iIndex] === 'Visible' ? true : false,
    clientname:
      GetAdminConfiguration.ClientName[iIndex] === 'Visible' ? true : false,
    planid: GetAdminConfiguration.PlanID[iIndex] === 'Visible' ? true : false,
    ssn: GetAdminConfiguration.SSN[iIndex] === 'Visible' ? true : false,
    certno:
      GetAdminConfiguration.CertificateNumber[iIndex] === 'Visible'
        ? true
        : false,
    altid1:
      GetAdminConfiguration.AlternateID1[iIndex] === 'Visible' ? true : false,
    altid2:
      GetAdminConfiguration.AlternateID2[iIndex] === 'Visible' ? true : false,
    medicareid:
      GetAdminConfiguration.MedicareID[iIndex] === 'Visible' ? true : false,
  });

  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();
  const {
    firstname,
    lastname,
    email,
    dob,
    addressline1,
    addressline2,
    city,
    statename,
    zipcode,
    relationship,
    phonenumber,
    clientid,
    clientname,
    planid,
    ssn,
    certno,
    altid1,
    altid2,
    medicareid,
  } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    GetAdminConfiguration.FirstName[iIndex] =
      state.firstname === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.firstname]);

  useEffect(() => {
    GetAdminConfiguration.LastName[iIndex] =
      state.lastname === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.lastname]);

  useEffect(() => {
    GetAdminConfiguration.Email[iIndex] =
      state.email === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.email]);

  useEffect(() => {
    GetAdminConfiguration.DateOfBirth[iIndex] =
      state.dob === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.dob]);

  useEffect(() => {
    GetAdminConfiguration.AddressLine1[iIndex] =
      state.addressline1 === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.addressline1]);

  useEffect(() => {
    GetAdminConfiguration.AddressLine2[iIndex] =
      state.addressline2 === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.addressline2]);

  useEffect(() => {
    GetAdminConfiguration.City[iIndex] =
      state.city === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.city]);

  useEffect(() => {
    GetAdminConfiguration.State[iIndex] =
      state.statename === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.statename]);

  useEffect(() => {
    GetAdminConfiguration.PostalCode[iIndex] =
      state.zipcode === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.zipcode]);

  useEffect(() => {
    GetAdminConfiguration.Relationship[iIndex] =
      state.relationship === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.relationship]);

  useEffect(() => {
    GetAdminConfiguration.PhoneNumber[iIndex] =
      state.phonenumber === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.phonenumber]);

  useEffect(() => {
    GetAdminConfiguration.ClientID[iIndex] =
      state.clientid === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.clientid]);

  useEffect(() => {
    GetAdminConfiguration.ClientName[iIndex] =
      state.clientname === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.clientname]);

  useEffect(() => {
    GetAdminConfiguration.PlanID[iIndex] =
      state.planid === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.planid]);

  useEffect(() => {
    GetAdminConfiguration.SSN[iIndex] =
      state.ssn === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.ssn]);

  useEffect(() => {
    GetAdminConfiguration.CertificateNumber[iIndex] =
      state.certno === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.certno]);

  useEffect(() => {
    GetAdminConfiguration.AlternateID1[iIndex] =
      state.altid1 === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.altid1]);

  useEffect(() => {
    GetAdminConfiguration.AlternateID2[iIndex] =
      state.altid2 === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.altid2]);

  useEffect(() => {
    GetAdminConfiguration.MedicareID[iIndex] =
      state.medicareid === true ? 'Visible' : 'Invisible';
  }, [iIndex, state.medicareid]);

  return (
    <div>
      <span className="d-block field-condition">
        A minimum 3 fields are required.
      </span>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Publish</th>
            <th style={{ textAlign: 'center' }}>Field</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Form.Group
                className="disabled-fields"
                controlId="formGridfirstname"
              >
                <Form.Label className="sr-only" for="firstname">
                  firstname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true} //Before it checked={firstname}
                  //onChange={handleChange}
                  id="firstname"
                  name="firstname"
                  disabled={true} //Before making it true, it was previously disabled = !personalIdentificationEditable || !hasEditPermission
                  isDisabled={true} //Before making it true, it was previously disabled = !hasEditPermission
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>First Name</td>
          </tr>
          <tr>
            <td>
              <Form.Group
                className="disabled-fields"
                controlId="formGridlastname"
              >
                <Form.Label className="sr-only" for="lastname">
                  lastname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="lastname"
                  name="lastname"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Last Name</td>
          </tr>
          {/*As Email Id feild is not required comment the below field*/}
          {/*<tr>
            <td>
              <Form.Group controlId="formGridemail">
                <Form.Label className="sr-only" for="email">
                  email
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={email}
                  onChange={handleChange}
                  id="email"
                  name="email"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Email</td>
          </tr>*/}
          <tr>
            <td>
              <Form.Group className="disabled-fields" controlId="formGriddob">
                <Form.Label className="sr-only" for="dob">
                  dob
                </Form.Label>
                <Form.Check
                  checked={true}
                  //onChange={handleChange}
                  id="dob"
                  name="dob"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Date of Birth</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridaddressline1">
                <Form.Label className="sr-only" for="addressline1">
                  addressline1
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={addressline1}
                  onChange={handleChange}
                  id="addressline1"
                  name="addressline1"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Address Line 1</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridaddressline2">
                <Form.Label className="sr-only" for="addressline2">
                  addressline2
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={addressline2}
                  onChange={handleChange}
                  id="addressline2"
                  name="addressline2"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Address Line 2</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridcity">
                <Form.Label className="sr-only">city</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={city}
                  id="city"
                  onChange={handleChange}
                  name="city"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>City</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridstatename">
                <Form.Label className="sr-only" for="statename">
                  statename
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={statename}
                  onChange={handleChange}
                  id="statename"
                  name="statename"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>State</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridzipcode">
                <Form.Label className="sr-only" for="zipcode">
                  zipcode
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={zipcode}
                  onChange={handleChange}
                  id="zipcode"
                  name="zipcode"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Postal Code</td>
          </tr>
          {GetAdminConfiguration.MemberType[iIndex] != 'Employee' && (
            <tr>
              <td>
                <Form.Group controlId="formGridrelationship">
                  <Form.Label className="sr-only" for="relationship">
                    relationship
                  </Form.Label>
                  <Form.Check
                    type="checkbox"
                    checked={relationship}
                    onChange={handleChange}
                    id="relationship"
                    name="relationship"
                    disabled={
                      !personalIdentificationEditable || !hasEditPermission
                    }
                    isDisabled={!hasEditPermission}
                    className={!hasEditPermission && 'disabled-checkbox'}
                  />
                </Form.Group>
              </td>
              <td>Relationship</td>
            </tr>
          )}
          <tr>
            <td>
              <Form.Group controlId="formGridphonenumber">
                <Form.Label className="sr-only" for="phonenumber">
                  phonenumber
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={phonenumber}
                  onChange={handleChange}
                  id="phonenumber"
                  name="phonenumber"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Phone Number</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridclientid">
                <Form.Label className="sr-only">clientid</Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={clientid}
                  onChange={handleChange}
                  id="clientid"
                  name="clientid"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Client ID</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridclientname">
                <Form.Label className="sr-only" for="clientname">
                  clientname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={clientname}
                  onChange={handleChange}
                  id="clientname"
                  name="clientname"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Client Name</td>
          </tr>
          {/*<tr>
            <td>
              <Form.Group controlId="formGridCheckbox1">
                <Form.Label className='sr-only'></Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={planid}
                  onChange={handleChange}
                  name="planid"/>
              </Form.Group>
            </td>
            <td>Plan ID</td>
          </tr> */}
          <tr>
            <td>
              <Form.Group className="disabled-fields" controlId="formGridSSN">
                <Form.Label className="sr-only" for="SSN">
                  SSN
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="SSN"
                  name="ssn"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>SSN</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridCheckbox1">
                <Form.Label className="sr-only"></Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={certno}
                  onChange={handleChange}
                  name="certno"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{CertificateNumberLabel}</td>
          </tr>
          <tr>
            <td>
              <Form.Group
                className="disabled-fields"
                controlId="formGridaltid1"
              >
                <Form.Label className="sr-only" for="altid1">
                  altid1
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="altid1"
                  name="altid1"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{AlternateID1Label}</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridaltid2">
                <Form.Label className="sr-only" for="altid2">
                  altid2
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={altid2}
                  onChange={handleChange}
                  id="altid2"
                  name="altid2"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{AlternateID2Label}</td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridmedicareid">
                <Form.Label className="sr-only" for="medicareid">
                  medicareid
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={medicareid}
                  onChange={handleChange}
                  id="medicareid"
                  name="medicareid"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Medicare ID</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default AdditionalFields;
